import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Activity, User, Globe } from "lucide-react";

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState("");
  useEffect(() => { api.get("/audit-logs").then(r => setLogs(r.data)); }, []);

  const filtered = logs.filter(l =>
    !filter ||
    l.action?.toLowerCase().includes(filter.toLowerCase()) ||
    l.user_email?.toLowerCase().includes(filter.toLowerCase()) ||
    l.resource?.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div data-testid="admin-auditoria">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-[0.18em] text-[#D4AF37] font-semibold mb-2">Auditoria</div>
        <h1 className="font-display text-3xl text-[#14213D] font-light">Logs de Auditoria</h1>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg">
        <div className="p-4 border-b border-gray-200">
          <input
            placeholder="Filtrar por ação, usuário ou recurso…"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="w-full md:w-96 border border-gray-200 rounded px-3 py-2 text-sm"
            data-testid="audit-filter"
          />
          <div className="text-xs text-gray-400 mt-2">{filtered.length} eventos registrados</div>
        </div>
        <div className="table-wrap">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left text-xs uppercase tracking-wider text-gray-500 font-semibold">
            <tr>
              <th className="px-5 py-3">Data/Hora</th>
              <th className="px-5 py-3">Usuário</th>
              <th className="px-5 py-3">Ação</th>
              <th className="px-5 py-3">Recurso</th>
              <th className="px-5 py-3">IP</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr><td colSpan={5} className="px-5 py-10 text-center text-gray-400">Sem registros</td></tr>
            )}
            {filtered.map((l, i) => (
              <tr key={i} className="border-t border-gray-100 hover:bg-gray-50" data-testid={`log-${i}`}>
                <td className="px-5 py-3 text-xs text-gray-500">{new Date(l.timestamp).toLocaleString("pt-BR")}</td>
                <td className="px-5 py-3">
                  {l.user_email ? (
                    <div className="flex items-center gap-1.5"><User size={12} className="text-gray-400" /><span className="text-gray-700">{l.user_email}</span></div>
                  ) : <span className="text-gray-400 text-xs">sistema</span>}
                </td>
                <td className="px-5 py-3">
                  <span className="font-mono text-xs text-[#14213D] bg-gray-50 px-2 py-0.5 rounded">{l.action}</span>
                </td>
                <td className="px-5 py-3 text-gray-600 text-xs">
                  {l.resource}{l.resource_id ? <span className="text-gray-400 ml-1">· {l.resource_id?.slice(0, 8)}</span> : null}
                </td>
                <td className="px-5 py-3 text-xs text-gray-400 flex items-center gap-1"><Globe size={11} />{l.ip || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}
